import axios from 'axios';
import { getQueryClient } from '@queries/QueryClientWrapper';
import { environment } from '@environments/environment';
import { OverviewKpi, ProductsParam } from '@models/Products';
import { constructRequest } from '@utils/serviceUtils/RequestFormatter';
import { RequestPayloadArgumentObject } from '@pages/product-analyzer/Product';
import { throwApiError } from '@services/utils/ErrorHandlers';

export const getProductsOverview = async (param: ProductsParam): Promise<OverviewKpi> => {
  let body: any;
  try {
    const qc = getQueryClient('products');

    const payload: RequestPayloadArgumentObject = {
      clientId: param.clientId,
      productType: param.productType,
      countryId: [param.countryId],
      productGroup: param.productGroup,
      periodType: param.periodType,
      period: param.period,
      comparisonPeriod: param.comparisonPeriod,
      appliedFilters: param.appliedFilters,
      kpi: param.kpi,
      calculateRollingPeriod: true,
      isMarket: param.isMarket,
      page: undefined,
      size: undefined,
      sortBy: undefined,
      sortDirection: undefined,
      sortKey: undefined,
      comparisonGrowth: undefined,
    };

    const queryKey = ['products-overview', payload] as const;
    const url = `${environment.baseUrl}/v2/products/overview`;
    body = constructRequest(payload);

    return await qc.ensureQueryData<OverviewKpi>({
      queryKey,
      queryFn: async ({ signal }) => {
        const { data } = await axios.post<OverviewKpi>(url, body, { signal });
        return data;
      },
    });
  } catch (err: any) {
    // Delegated error handling; helper always throws. Added explicit throw for Sonar compliance.
    throwApiError(err, { excludedBrand: body?.excludedBrand }); // NOSONAR
  }
};
